import { StoreState } from '../../types/ReduxMisc';
import { SiteColor } from '../../types/SiteColor';
import { ViewModeOOI } from '../../types/ViewMode';
import { DeviceType } from '../../types/DeviceType';
import { SiteStyles } from '@wix/cashier-common/dist/src/types/SiteStyles';
import { AppId } from '@wix/cashier-common/dist/src/enums/AppId';

export const selectIsSaveCardChecked = (state: StoreState): boolean =>
  state.uiState.isSaveCardChecked;
export const selectCardInstallments = (state: StoreState): number =>
  state.uiState.cardInstallments;
export const selectSiteStyles = (state: StoreState): SiteStyles =>
  state.tpaParams.siteStyles;
export const selectSiteTextColor = (state: StoreState): string =>
  selectSiteStyles(state)?.siteColors?.find(
    ({ reference }) => reference === SiteColor.Text
  )?.value;

export const selectConfiguration = (state: StoreState) =>
  state.tpaParams.configuration;
export const selectViewMode = (state: StoreState): ViewModeOOI =>
  selectConfiguration(state)?.viewMode;
export const selectIsSignedInUser = (state: StoreState) =>
  selectConfiguration(state)?.isSignedInUser;
export const selectIsMerchantContext = (state: StoreState) =>
  selectConfiguration(state)?.isMerchantContext;
export const selectAppId = (state: StoreState) =>
  selectConfiguration(state)?.appId as AppId;
export const selectAppInstanceId = (state: StoreState) =>
  selectConfiguration(state)?.appInstanceId;
export const selectAmount = (state: StoreState) =>
  selectConfiguration(state)?.amount;
export const selectCurrency = (state: StoreState) =>
  selectConfiguration(state)?.currency;
export const selectSnapshotId = (state: StoreState) =>
  selectConfiguration(state)?.snapshotId;

export const selectDeviceType = (state: StoreState): DeviceType =>
  state.tpaParams?.deviceType;
export const selectLocale = (state: StoreState): string =>
  state.tpaParams?.locale;
export const selectShouldApplySiteStyles = (state: StoreState): boolean =>
  state.tpaParams?.shouldApplySiteStyles;
